var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_52259_81595)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5563 0.458977C18.9647 -0.132604 18.0091 -0.132604 17.4175 0.458977L10 7.86133L2.58248 0.443808C1.9909 -0.147773 1.03527 -0.147773 0.443686 0.443808C-0.147895 1.03539 -0.147895 1.99102 0.443686 2.5826L7.86121 10.0001L0.443686 17.4176C-0.147895 18.0092 -0.147895 18.9649 0.443686 19.5564C1.03527 20.148 1.9909 20.148 2.58248 19.5564L10 12.1389L17.4175 19.5564C18.0091 20.148 18.9647 20.148 19.5563 19.5564C20.1479 18.9649 20.1479 18.0092 19.5563 17.4176L12.1388 10.0001L19.5563 2.5826C20.1327 2.00619 20.1327 1.03539 19.5563 0.458977Z",
    fill: "#979797"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_52259_81595"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseDark);
export default __webpack_public_path__ + "static/media/close_dark.4cddc5af5668c4b419f7477ef148c7c4.svg";
export { ForwardRef as ReactComponent };